import React, { useState, useEffect } from "react";

const Typewriter = () => {
  const [text, setText] = useState("");
  const [displayedText, setDisplayedText] = useState("");
  const [index, setIndex] = useState(0);
  const speed = 150; // Adjust the speed (milliseconds per character)

  const textToType = "< Hello ! Try Me Out />";

  useEffect(() => {
    const typeText = () => {
      if (index < textToType.length) {
        setDisplayedText(textToType.slice(0, index + 1));
        setIndex(index + 1);
      } else {
        setIndex(0);
        setDisplayedText("");
      }
    };

    const typeInterval = setInterval(typeText, speed);

    return () => clearInterval(typeInterval);
  }, [index]);

  return <div className="typewriter">{displayedText}</div>;
};

export default Typewriter;
